import axios from 'axios'
import {Message, MessageBox} from 'element-ui'

// import { Spin } from 'iview'
// 超时设定
axios.defaults.timeout = 15000
// 允许携带cookie
axios.defaults.withCredentials = true
axios.defaults.baseURL = '/api'
class HttpRequest {
  constructor () {
    this.queue = {}
  }

  getInsideConfig () {
    return {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  }

  destroy (url) {
    delete this.queue[url]
    if (!Object.keys(this.queue).length) {
      // Spin.hide()
    }
  }

  interceptors (instance, url) {
    // 请求拦截
    instance.interceptors.request.use(config => {
      // 添加全局的loading...
      if (!Object.keys(this.queue).length) {
        // Spin.show() // 不建议开启，因为界面不友好
      }
      this.queue[url] = true
      return config
    }, error => {
      return Promise.reject(error)
    })
    // 响应拦截
    instance.interceptors.response.use(res => {
      this.destroy(url)
      const { data } = res
      const { code, msg } = data
      if (code === -2) {
        const pathname = location.pathname
        if (pathname !== '/') {
          MessageBox.confirm('未检测到您的登录信息。请先前往登录界面，登录成功后再重新进入', '登录失败', {
            confirmButtonText: '确定',
            type: 'info',
            callback: () => {
              const link = window.location.href
              const loginUrl = window.location.protocol + '//' + window.location.host + '/login?redirect=' + encodeURIComponent(link)
              window.location.href = loginUrl
            }
          })
        } else {
          // go login
        }
        return Promise.reject(msg)
      } else {
        return data
      }
    }, error => {
      if (error && error.response) {
        switch (error.response.status) {
          case 400:
            error.message = '错误请求'
            break
          case 401:
            error.message = '未授权，请重新登录'
            break
          case 403:
            error.message = '拒绝访问'
            break
          case 404:
            error.message = '请求错误,未找到该资源'
            break
          case 405:
            error.message = '请求方法未允许'
            break
          case 408:
            error.message = '请求超时'
            break
          case 500:
            error.message = '服务器端出错'
            break
          case 501:
            error.message = '网络未实现'
            break
          case 502:
            error.message = '网络错误'
            break
          case 503:
            error.message = '服务不可用'
            break
          case 504:
            error.message = '网络超时'
            break
          case 505:
            error.message = 'http版本不支持该请求'
            break
          default:
            error.message = `连接错误${error.response.status}`
        }
      } else {
        error.message = '连接到服务器失败'
      }
      Message.error(error.message)
      return Promise.reject(error.message)
    })
  }

  request (options) {
    const instance = axios.create()
    options = Object.assign(this.getInsideConfig(), options)
    this.interceptors(instance, options.url)
    return instance(options)
  }
}

export default HttpRequest



// WEBPACK FOOTER //
// ./src/libs/axios.js